import React, { useEffect, useState } from 'react';
import SideNavbar from '../../Components/SideNavbar';
import { Link } from 'react-router-dom';
import './CSS/Subscription.css';
import axios from "axios";
import shrmImage from '../../Assets/Images/SHRM.png';
import heroImage from "../../Assets/Images/header photo.png";


const REACT_APP_API_URL = process.env.REACT_APP_API_URL;


const Subscription: React.FC = () => {

    const [role, setRole] = useState<string | null>(null);
    const [subscriptionType, setSubscriptionType] = useState<string | null>(null);
    const [isChargebeePaid, setIsChargebeePaid] = useState<string | null>(null);

    const subjectToken = localStorage.getItem('subjectToken');


    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        const storedSubscriptionType = localStorage.getItem('subscriptionType')
        const storedIsChargebeePaid = localStorage.getItem('isChargebeePaid');


        setRole(storedRole);
        setSubscriptionType(storedSubscriptionType)
        setIsChargebeePaid(storedIsChargebeePaid);
    }, []);
    console.log("Paid: " + isChargebeePaid);

    const handleBasicSubscribeClick = () => {
        const chargebeeLink = document.getElementById('chargebee-link-basic');
        if (chargebeeLink) {
            chargebeeLink.click();
        } else {
            console.error('Chargebee link not found');
        }

    };

    const handleBasicYearlySubscribeClick = () => {
        const chargebeeLink = document.getElementById('chargebee-link-annual');
        if (chargebeeLink) {
            chargebeeLink.click();
        } else {
            console.error('Chargebee link not found');
        }

    };

    const handleSpecialYearlySubscribeClick = () => {
        const chargebeeLink = document.getElementById('chargebee-link-special');
        if (chargebeeLink) {
            chargebeeLink.click();
        } else {
            console.error('Chargebee link not found');
        }

    };

    const handleCancelClick = async () => {
        try {
            const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/subscriptions/cancel';

            const response = await axios.get(endpoint, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${subjectToken}`,
                }
            });

        } catch (error) {
            console.error('Error canceling subscription:', error);
        }
    };



    return (
        <div className="subscription-container">
            <SideNavbar />
            <div className="subscription-content">
                <h1 className="subscription-title">Subscribe</h1>
                <p className="subscription-description">
                    To active your free trial begin by selecting a plan.
                </p>
                <div className="tier-cards">
                    {subscriptionType === 'ENTERPRISE' ? (
                        <div className="tier-card">
                            <h2 className="tier-title">Enterprise Subscription</h2>
                            <p className="tier-description">
                                This is Vize's enterprise subscription plan. After the trial period ends, the account will
                                be billed regularly according to this plan.
                            </p>
                            <div className="tier-features">
                                Includes:
                                <ul>
                                    <li>Everything included in Personal</li>
                                    <li>Unlimited members</li>
                                    <li>Alter enterprise library</li>
                                </ul>
                            </div>
                            <button className="cancel-button" onClick={handleCancelClick}>Cancel</button>
                        </div>
                    ) : (
                        <>
                            <div className="tier-card">
                                <h2 className="tier-title">Inclusion 2024 Show Special</h2>
                                <img src={shrmImage} alt="Team Communication" className="shrm-image"/>
                                <p className="tier-description">
                                    Yearly discounted rate for the VIZEdi Desktop Application for attendees of the SHRM
                                    2024 conference.
                                </p>
                                <div className="tier-features">
                                    Includes:
                                    <ul>
                                        <li>Real Time Term Checking</li>
                                        <li>Tone Analysis</li>
                                        <li>Single User</li>
                                        <li>25% Discount On Annual Plan</li>
                                        <li>2-Week Free Trial</li>
                                    </ul>
                                </div>
                                <div className="tier-footer">
                                    <button className="personal-button" onClick={handleSpecialYearlySubscribeClick}>
                                        Special Plan
                                    </button>
                                </div>
                            </div>
                            <div className="tier-card">
                                <h2 className="tier-title">Basic Plan</h2>
                                <p className="tier-description">
                                    This is Vize's personal subscription plan. Once the free-trial period ends, your
                                    account
                                    will be billed regularly based on this selected plan.
                                </p>
                                <div className="tier-features">
                                    Includes:
                                    <ul>
                                        <li>Real Time Term Checking</li>
                                        <li>Tone Analysis</li>
                                        <li>Single User</li>
                                        <li>7 day free trial</li>
                                    </ul>
                                </div>
                                {isChargebeePaid === 'true' ? (
                                    <div className="personal-button-row">
                                        <Link to="/account/applications" style={{ justifyContent: 'center', display: 'flex' }}>
                                            <button className="download-button">Download Application</button>
                                        </Link>
                                        <button className="cancel-button" onClick={handleCancelClick}>Cancel</button>
                                    </div>
                                ) : (
                                    <div className="personal-button-row">
                                        <button className="personal-button" onClick={handleBasicSubscribeClick}>
                                            Monthly Plan
                                        </button>
                                        <button className="personal-button" onClick={handleBasicYearlySubscribeClick}>
                                            Annual Plan
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="tier-card">
                                <h2 className="tier-title">Professional Plan</h2>
                                <p className="tier-description">
                                    This is Vize's enterprise subscription plan. After the trial period ends, the
                                    account will
                                    be billed regularly according to this plan.
                                </p>
                                <div className="tier-features">
                                    Includes:
                                    <ul>
                                        <li>Real Time Term Checking</li>
                                        <li>Tone Analysis</li>
                                        <li>Manage Users</li>
                                        <li>100+ Users</li>
                                    </ul>
                                </div>
                                <div className="tier-footer">
                                    <Link to="/account/book-meeting">
                                        <button className="get-started-button">Book Meeting</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="tier-card">
                                <h2 className="tier-title">Enterprise Plan</h2>
                                <p className="tier-description">
                                    This is Vize's enterprise subscription plan. After the trial period ends, the
                                    account will be billed regularly according to this plan.
                                </p>
                                <div className="tier-features">
                                    Includes:
                                    <ul>
                                        <li>Real Time Term Checking</li>
                                        <li>Tone Analysis</li>
                                        <li>Manage Users</li>
                                        <li>Custom Integrations</li>
                                        <li>Teams Dashboard</li>
                                        <li>Advanced Reporting</li>
                                        <li>Custom Users</li>
                                    </ul>
                                </div>
                                <a className="something" href="#" data-cb-type="checkout" id='chargebee-link-basic'
                                   data-cb-item-0="Basic-Plan-USD-Monthly" data-cb-item-0-quantity="1"></a>
                                <a className="something" href="#" data-cb-type="checkout" id='chargebee-link-annual'
                                   data-cb-item-0="Basic-Plan-USD-Yearly" data-cb-item-0-quantity="1"></a>
                                <a className="something" href="#" data-cb-type="checkout" id='chargebee-link-special'
                                   data-cb-item-0="Special-USD-Yearly" data-cb-item-0-quantity="1"></a>
                                <div className="tier-footer">
                                    <Link to="/account/book-meeting">
                                        <button className="get-started-button">Book Meeting</button>
                                    </Link>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Subscription;